import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { SessionService } from '../../../services/session.service';

@Component({
    selector: '.p-error'
})
export class ErrorComponent extends ComponentBase<HTMLInputElement> {

    public constructor(node: HTMLInputElement, private _sessionService: SessionService) {
        super(node);
    }    

    public onInit(): void {
        super.onInit();
        
        const sessionId = this._sessionService.getSessionId();
        this.setInnerHTML(`${sessionId?.toUpperCase()} - ${new Date().getTime()}`, '.p-error__session span');
    }
}